<template>
  <v-footer id="footer" class="mt-12" color="primary lighten-1">
    <v-row justify="center" no-gutters>
      <v-btn
        v-for="link in links"
        :key="link.id"
        color="white"
        text
        rounded
        class="my-2"
      >
        <router-link
          :to="link.path"
          style="text-decoration: none; color: inherit;"
        >
          {{ link.text }}
        </router-link>
      </v-btn>
      <v-col class="primary lighten-2 py-4 text-center white--text" cols="12">
        {{ new Date().getFullYear() }} — <strong>PosterDay</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data: () => ({
    links: [
      { text: "Home", path: "/" },
      { text: "About", path: "/about" },
      { text: "Blog", path: "blog" },
      { text: "Contact", path: "/contact" }
    ]
  }),
  methods: {
    // myMethod() {}
  }
};
</script>

<style lang="scss" scoped>
#footer {
}
</style>
